import { z } from 'zod';

export enum NewReservationScreenUrlParamsKeys {
    StartUtc = 'StartUtc',
    EndUtc = 'EndUtc',
    ReleasedUtc = 'ReleasedUtc',
    GroupId = 'GroupId',
    CustomerId = 'CustomerId',
    State = 'State',
    Origin = 'Origin',
    Purpose = 'Purpose',
    PartnerCompanyId = 'PartnerCompanyId',
    TravelAgencyId = 'TravelAgencyId',
    BookerId = 'BookerId',
    ProductIds = 'ProductIds',
    ServiceId = 'ServiceId',
    AvailabilityBlockId = 'AvailabilityBlockId',
    RateId = 'RateId',
    ResourceId = 'ResourceId',
    ResourceCategoryId = 'ResourceCategoryId',
    OccupancyData = 'OccupancyData',
}

export const newReservationScreenUrlParamsSchema = z.object({
    [NewReservationScreenUrlParamsKeys.StartUtc]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.EndUtc]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.ReleasedUtc]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.GroupId]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.CustomerId]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.State]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.Origin]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.Purpose]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.PartnerCompanyId]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.TravelAgencyId]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.BookerId]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.ProductIds]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.ServiceId]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.AvailabilityBlockId]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.RateId]: z.string().optional().nullable(),
    [NewReservationScreenUrlParamsKeys.ResourceId]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.ResourceCategoryId]: z.string().optional(),
    [NewReservationScreenUrlParamsKeys.OccupancyData]: z
        .record(z.string().transform((value) => (typeof value === 'string' ? Number(value) : value)))
        .optional(),
});

export type NewReservationScreenUrlParams = z.infer<typeof newReservationScreenUrlParamsSchema>;
